// src/components/Careers/Mission/Mission.js
import React from 'react';
import './Mission.css';

function Mission() {
  return (
    <section className="mission-section">
        <div className="mission-content-wrapper">
            <div className="mission-image-pane">
                <img
                    src="https://sendbird.imgix.net/cms/career-img.jpg?auto=format,compress&crop=faces&w=900"
                    alt="The Sendbird Team"
                    className="mission-image"
                />
            </div>
            <div className="mission-copy-pane">
                <h1 className="mission-title">Meet the global No. 1 <br />chat solution</h1>
                <p>Our mission is to build connections in a digital world. We believe that digital doesn’t have to mean impersonal. That physical boundaries shouldn’t create relationship boundaries. We believe in authenticity over superficiality, and in conversations over text messages.</p>
                <a href="/about" className="mission-link">About Sendbird</a>
            </div>
        </div>
    </section>
  );
}

export default Mission;